import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { buildWhatsAppUrl } from "../lib/phone";

/**
 * Compact tap-to-call + WhatsApp action buttons for a card.
 * Stops event propagation so it can sit inside a Link/card row.
 */
export function ContactActions({ phone, name, className = "", size = "sm", waMessage }) {
  if (!phone) return null;
  const clean = String(phone).replace(/\D/g, "");
  const msg = waMessage || `Namaste ${name || ""} 🙏`;
  const waUrl = buildWhatsAppUrl(phone, msg);
  const stop = (e) => { e.preventDefault(); e.stopPropagation(); };

  const dim = size === "sm" ? "w-9 h-9" : "w-10 h-10";
  const icon = size === "sm" ? "w-4 h-4" : "w-4 h-4";

  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <a
        href={`tel:${clean}`}
        onClick={stop}
        data-testid="contact-call-btn"
        aria-label="Call"
        className={`${dim} rounded-full bg-emerald-600 hover:bg-emerald-700 text-white grid place-items-center transition active:scale-95 shrink-0`}
      >
        <Phone className={icon} strokeWidth={2.5} />
      </a>
      <a
        href={waUrl || "#"}
        target="_blank"
        rel="noreferrer"
        onClick={(e) => { stop(e); if (!waUrl) e.preventDefault(); }}
        data-testid="contact-whatsapp-btn"
        aria-label="WhatsApp"
        className={`${dim} rounded-full bg-[#25D366] hover:bg-[#20b358] text-white grid place-items-center transition active:scale-95 shrink-0`}
      >
        <MessageCircle className={icon} strokeWidth={2.5} />
      </a>
    </div>
  );
}
